<template>
  <div class="com-box">
    <div class="field-item">
      <div class="field-item-title">品牌介绍</div>
      <!-- <van-switch v-model="form.boolShowIntro" size="24px" active-color="#FF6B31" inactive-color="#f4f4f4" @change="onFormChange"/> -->
      <van-radio-group v-model="form.boolShowIntro" direction="horizontal" icon-size="16px" checked-color="#FF6B31" @change="onFormChange">
        <van-radio :name="false">关闭</van-radio>
        <van-radio :name="true">开启</van-radio>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initForm(newVal);
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      form: {
        boolShowIntro: false,
      }
    }
  },
  methods: {
    initForm(val) {
      if (val) {
        this.form = {...val};
      }
    },
    onFormChange() {
      this.$emit('change', this.form);
    },
  }
}
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px
.field-item
  margin 15px 0
  display: flex
  justify-content: space-between
  align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  border-radius: 8px
  &-title
    color #323233
    font-weight 600
</style>